import type { ComponentConfig } from '@puckeditor/core'
import ColorField from './ColorField'
import PaddingField, { type PaddingValue, defaultPadding, paddingToStyle } from './PaddingField'

export interface BadgeProps {
    text: string
    backgroundColor: string
    textColor: string
    fontSize: number
    fontWeight: string
    borderRadius: number
    paddingX: number
    paddingY: number
    alignment: 'left' | 'center' | 'right'
    textTransform: 'none' | 'uppercase' | 'capitalize'
    padding: PaddingValue
}

export const BadgeBlock: ComponentConfig<BadgeProps> = {
    label: 'Badge',
    defaultProps: {
        text: 'NEW',
        backgroundColor: '#EF4444',
        textColor: '#FFFFFF',
        fontSize: 12,
        fontWeight: '700',
        borderRadius: 100,
        paddingX: 12,
        paddingY: 4,
        alignment: 'left',
        textTransform: 'uppercase',
        padding: defaultPadding,
    },
    fields: {
        text: { type: 'text', label: 'Text', contentEditable: true },
        backgroundColor: {
            type: 'custom',
            render: ({ value, onChange }) => <ColorField label="Background Color" value={value} onChange={onChange} />,
        },
        textColor: {
            type: 'custom',
            render: ({ value, onChange }) => <ColorField label="Text Color" value={value} onChange={onChange} />,
        },
        fontSize: { type: 'number', label: 'Font Size', min: 8, max: 24 },
        fontWeight: {
            type: 'select',
            label: 'Font Weight',
            options: [
                { label: 'Normal', value: '400' },
                { label: 'Medium', value: '500' },
                { label: 'Semi Bold', value: '600' },
                { label: 'Bold', value: '700' },
            ],
        },
        borderRadius: { type: 'number', label: 'Border Radius', min: 0, max: 100 },
        paddingX: { type: 'number', label: 'Horizontal Padding', min: 0, max: 48 },
        paddingY: { type: 'number', label: 'Vertical Padding', min: 0, max: 24 },
        alignment: {
            type: 'radio',
            label: 'Alignment',
            options: [
                { label: 'Left', value: 'left' },
                { label: 'Center', value: 'center' },
                { label: 'Right', value: 'right' },
            ],
        },
        textTransform: {
            type: 'select',
            label: 'Text Transform',
            options: [
                { label: 'None', value: 'none' },
                { label: 'UPPERCASE', value: 'uppercase' },
                { label: 'Capitalize', value: 'capitalize' },
            ],
        },
        padding: {
            type: 'custom',
            render: ({ value, onChange }) => <PaddingField value={value} onChange={onChange} />,
        },
    },
    render: ({ text, backgroundColor, textColor, fontSize, fontWeight, borderRadius, paddingX, paddingY, alignment, textTransform, padding }) => (
        <div style={{ textAlign: alignment, padding: paddingToStyle(padding) }}>
            <span style={{
                display: 'inline-block',
                backgroundColor,
                color: textColor,
                fontSize,
                fontWeight,
                borderRadius,
                padding: `${paddingY}px ${paddingX}px`,
                textTransform,
                lineHeight: 1.4,
                letterSpacing: textTransform === 'uppercase' ? '0.05em' : 'normal',
            }}>
                {text}
            </span>
        </div>
    ),
}
